import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as LoaderSecondary } from '../../../assets/SpinnerBlack.svg';
import HeaderBasicLayout from '../../../components/header/headerBasicLayout/HeaderBasicLayout';
import RechargePowerInfo from '../../../components/rechargePowerInfo/RechargePowerInfo';
import { useBrandContext } from '../../../context/BrandContext';
import { useToast } from '../../../context/ToastModalContext';
import { getTransactionById } from '../../../services/extractService';
import {
  formatKw,
  formatSpottCashChargedDetail,
  formatTimeWithoutDays,
} from '../../../utils/format';
import './RechargeExtract.css';
import { useHeaderContext } from '../../../context/HeaderContext';

const RechargeExtract: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [historyTransaction, setHistoryTransaction] = useState<any>({});
  //const [orderItemsRecipe, setOrderItemsRecipe] = useState<any>();
  const { id } = useParams();

  const brandContext = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();
  const { showToast } = useToast();

  const getRechargeExtractData = async (id: string) => {
    try {
      const response = await getTransactionById(id);
      //setOrderItemsRecipe(response.order.orderItems);
      setIsError(false);
      const history = {
        meterStop: formatKw(response?.meterStop),
        timer: formatSpottCashChargedDetail(
          response?.startTime,
          response?.stopTime
        ),
        chargerName: response?.chargerSite?.csName,
        chargerSiteFormattedAddress: response?.chargerSite?.csFormattedAddress,
        chargerNumber: `${response?.chargePoint?.cpCode}-${response.chargePoint?.cpCm?.chargerModelsConnectors[0]?.connectorId}`,
        amount: response?.amount,
        chargeModel: response?.chargePoint?.cpCm,
        chargeTime: response?.chargeTime,
        valueKWH: response?.startPricePeriod?.sppPrice,
        manufacturerName:
          response?.chargePoint?.cpCm?.cmManufacturer?.manufacturerName,
        sppPriceHour: Number(response?.startPricePeriod?.sppPriceHour),
        startPriceProfilePeriod: response?.startPriceProfilePeriod,
        cmSpeed: response.chargePoint.cpCm?.cmSpeed,
        uvName: response.uvName,
        uvLicencePlate: response.uv?.uvLicencePlate,
        vmName: response.uv?.uvVm?.vmName,
        transaction: {
          order: response.order,
        },
      };
      setHistoryTransaction(history);
      setIsLoading(false);
    } catch (er) {
      setIsLoading(false);
      setIsError(true);
      showToast({
        title: 'Falha',
        messageModal: 'Falha ao carregar Recarga. Por favor, tente novamente',
        textEnterButton: 'Tentar novamente',
        allowButtonClosed: true,
        handleEnterButton: () => getRechargeExtractData(id),
        closeButtonText: 'Fechar',
      });
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      getRechargeExtractData(id);
    }
  }, [id]);

  const backNavigation = useCallback(() => {
    navigate(`/${brandContext.brandName}/extract`);
  }, [brandContext.brandName, navigate]);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Transação',
      backNavigation: () => backNavigation(),
    });
    return () => setHeaderConfig({});
  }, [backNavigation, navigate, setHeaderConfig]);

  return (
    <>
      {historyTransaction && !isLoading ? (
        <div className='recharge-extract-container'>
          <div className='recharge-extract-content'>
            <span className='recharge-extract-kwh'>
              <span className='type'>Recarga</span>{' '}
              {historyTransaction?.meterStop} kWh
            </span>
            <span className='recharge-extract-date-time'>
              {historyTransaction?.timer}
            </span>
            {historyTransaction?.uvLicencePlate && (
              <h4>
                {historyTransaction?.uvLicencePlate}
                {historyTransaction?.uvName
                  ? ` - ${historyTransaction?.uvName}`
                  : ''}
              </h4>
            )}
            {historyTransaction.uvName && <h5>{historyTransaction.vmName}</h5>}
            <div className='recharge-extract-detail-lines'>
              <div className='charger-name'>
                {historyTransaction.chargerName}
              </div>
              <div className='address'>
                <span className='recharge-extract-address'>
                  {historyTransaction.chargerSiteFormattedAddress}
                </span>
              </div>
            </div>

            <div className='recharge-extract-charger-info'>
              <div className='title'>
                Carregador - {historyTransaction?.chargerNumber}
              </div>
              <div className='cpCm-data'>
                <div>
                  {historyTransaction.cmSpeed}
                  {' - '}
                </div>
                <div className='estimated-kw'>
                  {formatKw(historyTransaction?.chargeModel?.cmMaxPower)} kW
                </div>
              </div>
            </div>
          </div>
          <RechargePowerInfo
            conectorStatus={historyTransaction}
            isStopTransaction={true}
            time={formatTimeWithoutDays(historyTransaction?.chargeTime)}
            //CostChargeInfo={historyTransaction?.startPriceProfilePeriod}
            priceProfile={historyTransaction?.startPriceProfilePeriod}
            initialRechargerInfo={historyTransaction}
            isModDark={true}
          />
        </div>
      ) : !isLoading && !isError ? (
        <span>Não há transações</span>
      ) : (
        !isError && <LoaderSecondary />
      )}
    </>
  );
};

export default RechargeExtract;
